import React, { useState, lazy, Suspense } from 'react';
import { motion } from 'framer-motion';

// Import gallery images from assets folder
import img1 from '../assets/images1/img/WhatsApp Image 2026-03-05 at 7.50.16 PM.jpeg';
import img2 from '../assets/images1/img/WhatsApp Image 2026-03-05 at 7.50.17 PM (1).jpeg';
import img3 from '../assets/images1/img/WhatsApp Image 2026-03-05 at 7.50.17 PM (2).jpeg';
import img4 from '../assets/images1/img/WhatsApp Image 2026-03-05 at 7.50.17 PM (3).jpeg';
import img5 from '../assets/images1/img/WhatsApp Image 2026-03-05 at 7.50.17 PM.jpeg';
import img6 from '../assets/images1/img/WhatsApp Image 2026-03-05 at 7.51.07 PM.jpeg';

const galleryImages = [
  { id: 1, src: img1, alt: 'Project 1' },
  { id: 2, src: img2, alt: 'Project 2' },
  { id: 3, src: img3, alt: 'Project 3' },
  { id: 4, src: img4, alt: 'Project 4' },
  { id: 5, src: img5, alt: 'Project 5' },
  { id: 6, src: img6, alt: 'Project 6' }
];

function Projects({ setCurrentPage, id = "projects" }) {
 const [selectedImage, setSelectedImage] = useState(null);

 return (
    <section id={id} className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4 max-w-7xl">
        {/* Header Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3 }}
          className="text-center mb-16"
        >
          <motion.h2 
            className="text-3xl sm:text-4xl md:text-6xl font-bold text-gray-900 mb-6"
          >
            Our <span className="text-yellow-500">Portfolio</span>
          </motion.h2>
          
          <motion.div 
            className="w-24 h-1 bg-yellow-500 mx-auto mb-8 rounded-full"
          />
          
          <motion.p 
            className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4"
          >
            Explore our exceptional work across diverse sectors, showcasing premium craftsmanship and innovative design solutions for prestigious clients.
          </motion.p>
        </motion.div>

        <div className="text-center mb-16">
          <button
            onClick={() => setCurrentPage && setCurrentPage('portfolio')}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-lg text-base sm:text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl h-14 sm:h-16 min-w-[160px] sm:min-w-[200px]"
          >
            View My Portfolio
          </button>
        </div>

        {/* Image Gallery Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3 }}
          className="mb-16 gallery-container"
        >
          <motion.h2 
            className="gallery-title text-3xl sm:text-4xl md:text-6xl font-bold text-black mb-8"
          >
            Our Projects Gallery
          </motion.h2>
          
          <motion.div 
            className="w-24 h-1 bg-yellow-500 mx-auto mb-8 rounded-full"
          />

          <div className="flex justify-center items-center flex-col w-full">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-6xl">
              {galleryImages.map((image, index) => (
                <motion.div
                  key={image.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3 }}
                  className="group relative overflow-hidden rounded-2xl cursor-pointer gallery-item glass"
                  onClick={() => setSelectedImage(image)}
                  whileHover={{ scale: 1.05 }}
                >
                  <div className="aspect-w-4 aspect-h-3">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-64 object-cover rounded-xl"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <motion.div
          initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md lightbox-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <motion.div
            initial={{ scale: 0.8 }}
          animate={{ scale:1 }}
            exit={{ scale: 0.8 }}
            className="relative max-w-5xl max-h-[90vh] p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 backdrop-blur-sm"
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
            />
          </motion.div>
        </motion.div>
      )}
    </section>
  );
}

export default Projects;
